<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="'cookie-settings-title' | translate"
  [nzFooter]="footerTemplate"
  [nzWidth]="'min(90vw, 700px)'"
  [nzClosable]="true"
  [nzMaskClosable]="false"
  (nzOnCancel)="onClose()"
  [nzZIndex]="10000"
  nzCentered>
  <div *nzModalContent class="cookie-settings">
    <p class="cookie-settings__intro">
      {{ 'cookie-settings-intro' | translate }}
    </p>

    <nz-divider></nz-divider>

    @for (category of categories; track category.key) {
      <div class="cookie-category">
        <div class="cookie-category__header">
          <div class="cookie-category__info">
            <h4 class="cookie-category__title">
              {{ category.titleKey | translate }}
              @if (category.required) {
                <nz-tag nzColor="blue" class="cookie-category__required-tag">
                  {{ 'cookie-category-required' | translate }}
                </nz-tag>
              }
            </h4>
            <p class="cookie-category__description">
              {{ category.descriptionKey | translate }}
            </p>
          </div>

          <nz-switch
            [ngModel]="getCategoryPreference(category.key)"
            (ngModelChange)="toggleCategory(category.key, $event)"
            [nzDisabled]="isRequired(category.key)"
            [nzCheckedChildren]="'cookie-category-enabled' | translate"
            [nzUnCheckedChildren]="'cookie-category-disabled' | translate"></nz-switch>
        </div>

        @if (category.services && category.services.length > 0) {
          <div class="cookie-category__services">
            <span class="cookie-category__services-label">{{ 'cookie-services-used' | translate }}:</span>
            <div class="cookie-category__services-list">
              @for (service of category.services; track service) {
                <nz-tag nzColor="default">{{ service | translate }}</nz-tag>
              }
            </div>
          </div>
        }

        <nz-divider></nz-divider>
      </div>
    }
  </div>

  <ng-template #footerTemplate>
    <div class="cookie-settings__footer">
      <button nz-button nzType="default" (click)="onClose()" [disabled]="saving()">
        {{ 'cancel' | translate }}
      </button>

      <button nz-button nzType="primary" (click)="onSave()" [nzLoading]="saving()">
        {{ 'cookie-settings-save' | translate }}
      </button>
    </div>
  </ng-template>
</nz-modal>
